module.exports = __webpack_public_path__ + "static/media/screenshot.8db6f646.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/screenshot.jpeg
// module id = 287
// module chunks = 0